import { WorldTransform as o, Transform as s } from "./components.js";
import { TransformHierarchySystem as a } from "./systems.js";
const m = {
  systems: [a],
  components: {
    Transform: s,
    WorldTransform: o
  },
  config: {
    defaults: {
      transform: {
        rotW: 1,
        scaleX: 1,
        scaleY: 1,
        scaleZ: 1
      },
      "world-transform": {
        rotW: 1,
        scaleX: 1,
        scaleY: 1,
        scaleZ: 1
      }
    },
    validations: [
      {
        condition: (n, r) => "world-transform" in r,
        warning: `"world-transform" is read-only.
  Use "transform" for local transforms, or "body" for physics objects`
      }
    ]
  }
};
export {
  m as TransformsPlugin
};
//# sourceMappingURL=plugin.js.map
